module.exports = __webpack_public_path__ + "static/img/wariant1.f8e0ecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wariant1.jpg
// module id = wJhr
// module chunks = 1